
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Card from '../../components/base/Card';

export default function About() {
  const values = [
    {
      title: 'الشفافية',
      description: 'نلتزم بأعلى مستويات الشفافية في جميع تعاملاتنا',
      icon: 'ri-eye-line'
    },
    {
      title: 'الاحتراف',
      description: 'فريق من الخبراء المتخصصين في مختلف المجالات',
      icon: 'ri-user-star-line'
    },
    {
      title: 'الأمان',
      description: 'أولوية قصوى للسلامة والأمن في جميع مشاريعنا',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'الاستدامة',
      description: 'حلول مستدامة تراعي البيئة والمجتمع',
      icon: 'ri-leaf-line'
    },
    {
      title: 'الابتكار',
      description: 'نستخدم أحدث التقنيات والأساليب المبتكرة',
      icon: 'ri-lightbulb-line'
    }
  ];

  const team = [
    {
      name: 'DR. Joseph AlPark',
      position: 'Chairman',
      image: 'Professional business executive chairman in formal attire, confident corporate leader in modern office environment, clean background with professional lighting and corporate atmosphere&width=300&height=400&seq=joseph-chair&orientation=portrait'
    },
    {
      name: 'Ahmad AlBasarah',
      position: 'CEO',
      image: 'Professional CEO in business suit, executive leader in corporate environment, confident business professional with modern office background and clean corporate styling&width=300&height=400&seq=ahmad-ceo&orientation=portrait'
    },
    {
      name: 'Ayyoob Kachery',
      position: 'Consultant',
      image: 'Professional business consultant in formal attire, experienced advisor in corporate setting, clean modern office background with professional business atmosphere&width=300&height=400&seq=ayyoob-consultant&orientation=portrait'
    },
    {
      name: 'Mohammad Toumi Safer',
      position: 'Partner & Director',
      image: 'Professional business partner and director in executive attire, senior management professional in modern corporate office, clean background with business professional styling&width=300&height=400&seq=mohammad-partner&orientation=portrait'
    },
    {
      name: 'Yousef Abdulaziz Al Aradah',
      position: 'Consultant',
      image: 'Professional business director in formal business attire, executive manager in corporate environment, modern office setting with clean professional background&width=300&height=400&seq=yousef-director&orientation=portrait'
    }
  ];

  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">من نحن</span>
          </nav>
        </div>
      </div>
      
      <main>
        {/* Hero Section */}
        <section 
          className="py-32 relative"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/8076a26b294423a3138abfd253d6f258.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="container mx-auto px-4 text-center text-white">
            <h1 className="text-6xl font-bold mb-6">من نحن</h1>
            <p className="text-2xl max-w-4xl mx-auto leading-relaxed">
              شركة كويتية رائدة في مجال الأعمال متعددة الأنشطة، نبني الثقة من خلال التميز والجودة
            </p>
          </div>
        </section>

        {/* About Us */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <Card padding="lg">
                <h2 className="text-4xl font-bold text-[#595A5C] mb-8 text-center">نبذة عن الشركة</h2>
                <p className="text-xl text-gray-700 leading-relaxed mb-8">
                  شركة فيبا التجارية هي شركة كويتية متعددة الأنشطة تأسست لتكون رائدة في مجال البنية التحتية والتطوير العمراني. 
                  نحن نفخر بتقديم حلول شاملة ومتكاملة تشمل البنية التحتية والطرق، تطوير المدن والمجمعات، العقود الحكومية والخاصة، 
                  قطاع البترول والطاقة، تجارة الذهب والمعادن الثمينة، التسليح والمعدات الدفاعية، بالإضافة إلى خدمات الاستشارات المتخصصة.
                </p>
                <p className="text-xl text-gray-700 leading-relaxed">
                  تتميز شركتنا بفريق من الخبراء المتخصصين وشبكة واسعة من الشراكات الاستراتيجية التي تمكننا من تنفيذ المشاريع 
                  الكبرى بأعلى معايير الجودة والاحترافية، مع الالتزام الكامل بالمعايير الدولية والمحلية في جميع أعمالنا.
                </p>
              </Card>
            </div>
          </div>
        </section>

        {/* Vision, Mission, Values */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
              <Card className="text-center h-full">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#595A5C] mb-4">رؤيتنا</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  أن نكون الاسم الأول في منطقة الخليج العربي في مجال الأعمال متعددة التخصصات، 
                  ونموذجاً يحتذى به في التميز والريادة والابتكار.
                </p>
              </Card>
              
              <Card className="text-center h-full">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#595A5C] mb-4">رسالتنا</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  تقديم حلول موثوقة ومستدامة بأعلى المعايير العالمية، والمساهمة في التنمية 
                  الاقتصادية والعمرانية من خلال مشاريع نوعية تخدم المجتمع والوطن.
                </p>
              </Card>
              
              <Card className="text-center h-full">
                <div className="w-20 h-20 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-heart-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#595A5C] mb-4">قيمنا</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  الشفافية والاحتراف والأمان والاستدامة والابتكار - هذه القيم تشكل أساس 
                  عملنا وتوجه كل قراراتنا وأنشطتنا اليومية.
                </p>
              </Card>
            </div>

            <div className="max-w-4xl mx-auto">
              <h3 className="text-3xl font-bold text-center text-[#595A5C] mb-12">قيمنا الأساسية</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {values.map((value, index) => (
                  <div key={index} className="text-center group">
                    <div className="w-16 h-16 bg-[#E71B25] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-[#d11620] transition-colors duration-300">
                      <i className={`${value.icon} text-2xl text-white`}></i>
                    </div>
                    <h4 className="text-xl font-bold text-[#595A5C] mb-2">{value.title}</h4>
                    <p className="text-gray-600">{value.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team - Organizational Chart */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-[#595A5C] mb-6">الهيكل الإداري</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                تنظيم قيادي واضح يضمن سرعة القرار وجودة التنفيذ
              </p>
            </div>
            
            {/* Desktop Organizational Chart */}
            <div className="hidden md:block max-w-6xl mx-auto">
              {/* Level 1 - Chairman */}
              <div className="flex justify-center mb-10">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-6 text-center min-w-[300px] relative">
                  <h3 className="text-2xl font-bold text-[#2B2C2E] mb-2">DR. Joseph AlPark</h3>
                  <p className="text-[#E71B25] font-medium text-lg">رئيس مجلس الإدارة</p>
                  
                  {/* Connection Line Down */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0.5 h-10 bg-[#C3AAAB]"></div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 w-2 h-2 bg-[#C3AAAB] rounded-full -ml-1"></div>
                </div>
              </div>

              {/* Level 2 - CEO */}
              <div className="flex justify-center mb-10">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center min-w-[280px] relative">
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-2">Ahmad AlBasarah</h3>
                  <p className="text-[#E71B25] font-medium">الرئيس التنفيذي</p>
                  
                  {/* Connection Line Down */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0.5 h-10 bg-[#C3AAAB]"></div>
                  
                  {/* Horizontal Line */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 w-96 h-0.5 bg-[#C3AAAB] -ml-48"></div>
                  
                  {/* Connection Points */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 w-2 h-2 bg-[#C3AAAB] rounded-full -ml-1"></div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 -translate-x-32 w-2 h-2 bg-[#C3AAAB] rounded-full -ml-1"></div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 translate-x-32 w-2 h-2 bg-[#C3AAAB] rounded-full -ml-1"></div>
                  
                  {/* Vertical Lines to Level 3 */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 -translate-x-32 w-0.5 h-10 bg-[#C3AAAB]"></div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 w-0.5 h-10 bg-[#C3AAAB]"></div>
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 translate-y-10 translate-x-32 w-0.5 h-10 bg-[#C3AAAB]"></div>
                </div>
              </div>

              {/* Level 3 - Directors */}
              <div className="flex justify-center gap-8 mt-20">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center min-w-[220px]">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Ayyoob Kachery</h3>
                  <p className="text-[#E71B25] font-medium">مستشار</p>
                </div>
                
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center min-w-[220px]">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Mohammad Toumi Safer</h3>
                  <p className="text-[#E71B25] font-medium">شريك ومدير</p>
                </div>
                
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center min-w-[220px]">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Yousef Abdulaziz Al Aradah</h3>
                  <p className="text-[#E71B25] font-medium">شريك - مستشار</p>
                </div>
              </div>
            </div>

            {/* Mobile/Tablet Accordion Layout */}
            <div className="md:hidden max-w-md mx-auto">
              {/* Level 1 */}
              <div className="mb-6">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center relative">
                  <h3 className="text-xl font-bold text-[#2B2C2E] mb-2">DR. Joseph AlPark</h3>
                  <p className="text-[#E71B25] font-medium">رئيس مجلس الإدارة</p>
                  
                  {/* Connection Line */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-[#C3AAAB]"></div>
                </div>
              </div>

              {/* Level 2 */}
              <div className="mb-6">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-5 text-center relative">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Ahmad AlBasarah</h3>
                  <p className="text-[#E71B25] font-medium">الرئيس التنفيذي</p>
                  
                  {/* Connection Line */}
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-[#C3AAAB]"></div>
                </div>
              </div>

              {/* Level 3 */}
              <div className="space-y-4">
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-4 text-center">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Ayyoob Kachery</h3>
                  <p className="text-[#E71B25] font-medium text-sm">مستشار</p>
                </div>
                
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-4 text-center">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Mohammad Toumi Safer</h3>
                  <p className="text-[#E71B25] font-medium text-sm">شريك - مستشار</p>
                </div>
                
                <div className="bg-white border border-[#C3AAAB44] rounded-xl shadow-lg p-4 text-center">
                  <h3 className="text-lg font-bold text-[#2B2C2E] mb-2">Yousef Abdulaziz Al Aradah</h3>
                  <p className="text-[#E71B25] font-medium text-sm">شريك - مستشار</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}
